export const productSchema = {
  $id: '/product.schema.json',
  $schema: 'http://json-schema.org/draft-07/schema',
  title: 'ProductSchema',
  type: 'object',
  description: 'Json schema that represents the product content type.',
  additionalProperties: false,
  properties: {
    link: {
      type: 'object',
      description: 'A string url for external or internal links',
      properties: {
        to: {
          description: 'Url string',
          type: 'string',
        },
        replacements: {
          description:
            'Directive to interpolate a url with dynamic values taken from a resource.',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              source: {
                type: 'object',
                description:
                  'An object that concludes a json path and a resource to switch json path contexts.',
                properties: {
                  jsonPath: {
                    description:
                      'The json path that points to a value of input data.',
                    type: 'string',
                  },
                  resource: {
                    type: 'string',
                    description:
                      'The data context of the query, it is used for 3rd party data like tenants, it defaults to _self which is the product data.',
                    enum: ['tenant', '_self'],
                  },
                  regex: {
                    type: 'object',
                    properties: {
                      match: {
                        description: 'Regex pattern for matching',
                        type: 'string',
                      },
                      replaceValue: {
                        description:
                          'The replacement value for the regex match.',
                        type: 'string',
                      },
                    },
                    required: ['match', 'replaceValue'],
                  },
                },
                required: ['jsonPath', 'resource'],
              },
              key: {
                description: 'The interpolation key.',
                type: 'string',
              },
            },
            required: ['key', 'source'],
          },
        },
        type: {
          type: 'string',
          enum: ['external-link'],
        },
      },
      required: ['type', 'to'],
    },
    baseUrl: {
      type: 'object',
      description:
        'The base url of the call to action url, based in environment.',
      properties: {
        dev: {
          type: 'string',
        },
        qa: {
          type: 'string',
        },
        'pre-production': {
          type: 'string',
        },
        production: {
          type: 'string',
        },
        staging: {
          type: 'string',
        },
      },
      required: ['dev', 'qa', 'pre-production', 'staging', 'production'],
    },
    icon: {
      type: 'object',
      properties: {
        src: {
          description: 'The src url of an icon with type url.',
          type: 'string',
        },
        type: {
          type: 'string',
          description: 'The type of an icon',
          enum: ['url'],
        },
      },
      required: ['src', 'type'],
    },
    name: {
      description: "The product's title",
      type: 'string',
    },
    displayName: {
      description: "The product's display name",
      type: 'object',
      properties: {
        source: {
          type: 'object',
          description:
            'An object that concludes a json path and a resource to switch json path contexts.',
          properties: {
            jsonPath: {
              description:
                'The json path that points to a value of input data.',
              type: 'string',
            },
            resource: {
              type: 'string',
              description:
                'The data context of the query, it is used for 3rd party data like tenants, it defaults to _self which is the quick action data.',
              enum: ['tenant', '_self'],
            },
            regex: {
              type: 'object',
              properties: {
                match: {
                  description: 'Regex pattern for matching',
                  type: 'string',
                },
                replaceValue: {
                  description: 'The replacement value for the regex match.',
                  type: 'string',
                },
              },
              required: ['match', 'replaceValue'],
            },
            replacements: {
              description:
                'Directive to interpolate a url with dynamic values taken from a resource.',
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  source: {
                    type: 'object',
                    description:
                      'An object that concludes a json path and a resource to switch json path contexts.',
                    properties: {
                      jsonPath: {
                        description:
                          'The json path that points to a value of input data.',
                        type: 'string',
                      },
                      resource: {
                        type: 'string',
                        description:
                          'The data context of the query, it is used for 3rd party data like tenants, it defaults to _self which is the product data.',
                        enum: ['tenant', '_self'],
                      },
                      regex: {
                        type: 'object',
                        properties: {
                          match: {
                            description: 'Regex pattern for matching',
                            type: 'string',
                          },
                          replaceValue: {
                            description:
                              'The replacement value for the regex match.',
                            type: 'string',
                          },
                        },
                        required: ['match', 'replaceValue'],
                      },
                    },
                    required: ['jsonPath', 'resource'],
                  },
                  key: {
                    description: 'The interpolation key.',
                    type: 'string',
                  },
                },
                required: ['key', 'source'],
              },
            },
          },
          required: ['jsonPath', 'resource'],
        },
      },
      required: ['source'],
    },
    description: {
      description: "The product's description",
      type: 'string',
    },
    openInTab: {
      type: 'boolean',
      default: true,
    },
    color: {
      type: 'string',
      description:
        "A color string which is defined in the SDS and defines the icon's color and background color of the quick action. (only the colors that have 100 and 600 variations from SDS are supported",
      default: 'blackAlpha',
      enum: [
        'primary',
        'red',
        'gray',
        'blackAlpha',
        'whiteAlpha',
        'teal',
        'purple',
        'orange',
        'yellow',
        'green',
        'blue',
        'pink',
      ],
    },
  },
  required: ['name', 'displayName', 'description', 'link', 'icon', 'color'],
};
